<mat-card
  [@cardAnimator]="animationState"
  (@cardAnimator.done)="resetAnimationState()"
  class="contrast mat-card-inline-sm"
  [class.banner-info]="selected">
  <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
    <div [fxFlex]="showCategory && item?.categoryName ? 70 : 100" fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="10px" fxLayout.lt-sm="column" fxLayoutGap.lt-sm="5px">
      <asset-upload #assetUploadComponent
          [hideButtons]="true"
          (asset)="onAssetLoad($event)">
          <div class="image-container" fxLayout="row" fxLayoutAlign="center center">
            <ng-container *ngIf="!thumbnailData && item?.thumbnailUrl">
              <img [src]="item.thumbnailUrl" class="thumbnail">
              
              <div class="overlay-icon" fxLayout="row" fxLayoutAlign="end center">
                <button class="small-icon" mat-icon-button color="accent" matTooltip="Upload new thumbnail" (click)="triggerChildFileUpload($event);">
                  <mat-icon>add_photo_alternate</mat-icon>
                </button>
              </div>
            </ng-container>
    
            <ng-container *ngIf="thumbnailData">
              <img [src]="thumbnailData" class="thumbnail">
                 
              <div class="overlay-icon" fxLayout="column" fxLayoutAlign="center center">
                <button class="small-icon" mat-icon-button color="primary" matTooltip="Cancel new thumbnail" (click)="cancelThumbnailUpload()">
                  <mat-icon>close</mat-icon>
                </button>
                <button class="small-icon" mat-icon-button color="accent" matTooltip="Save new thumbnail" (click)="saveThumbnailUpload()">
                  <mat-icon>done</mat-icon>
                </button>
              </div>
            </ng-container>
            
            <ng-container *ngIf="!thumbnailData && !item?.thumbnailUrl">
              <img src="/assets/images/add-image-icon.svg" class="thumbnail banner-incomplete">
              
              <div class="overlay-icon" fxLayout="row" fxLayoutAlign="end center">
                <button class="small-icon" mat-icon-button color="accent" matTooltip="Upload new thumbnail" (click)="triggerChildFileUpload($event);">
                  <mat-icon>add_photo_alternate</mat-icon>
                </button>
              </div>
            </ng-container>
          </div>
        </asset-upload>
      <div fxLayout="column" fxLayoutAlign="center start" fxLayoutAlign.lt-sm="center center">
        <strong [ngClass.lt-sm]="{'card-title': true}" [matTooltip]="item?.displayName !== item?.themeName ? 'Original name: ' + item?.themeName : ''" [class.readonly]="readonly" [innerHtml]="item?.displayName | encodeHtml | highlight: searchValue"></strong>
        <small [class.readonly]="readonly" fxFlex="100" *ngIf="item?.themeType">{{ themeTypeEnum[item?.themeType] }}</small>
      </div>
    </div>
    <div *ngIf="showCategory && item?.categoryName" fxFlex="30" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column">
      <small class="text-info">{{ item.categoryName }}</small>
    </div>
  </mat-card-content>
</mat-card>